import { api } from "./api";

/* Fetches the role-scoped "open work" payload used by the global
   <OpenWorkBar/> ribbon. Returns null for anonymous (no ribbon shown). */
const ENDPOINTS = {
  owner_builder: "/owner-portal/open-work",
  architect: "/architect-portal/open-work",
  city_staff: "/city-portal/open-work",
  platform_admin: "/admin-portal/open-work",
};

export async function fetchOpenWork(role, userId) {
  const path = ENDPOINTS[role];
  if (!path || !userId) return null;
  const { data } = await api.get(path, { params: { user_id: userId } });
  return data;
}
